import store from "../../store.js";
import { Api } from "@/core/api.js";
import i18n from "@/i18n";
import router from "../../router.js";
import { getBackofficeGestorTypeSelectOptions } from "@/constants/backofficeUserTypes.js";

const USER_BO_TYPE_OPTIONS = getBackofficeGestorTypeSelectOptions();

const api = new Api();

// initial state
const state = {
  routing: {
    home: {
      label: "init",
      url: "/",
      parent_id: -1,
    },
    clubs: {
      label: "params.club",
      url: "/club",
      actions: {
        main: {
          label: "clubs.label",
          url: "/club/add",
        },
        other: [
          {
            label: "Exportar",
            action: "export",
            type: "list",
          },
          {
            label: "clubs.rel_club_event",
            action: "rel_club_event",
            only_event: true,
          },
        ],
      },
      parent_id: "home",
      columns: [
        {
          label: "params.shield",
          param: "shield",
          type: "image",
          width: "50px",
          sortable: false,
          fixed: true,
        },
        {
          label: "params.name",
          param: "name",
          type: "string",
          width: "300px",
          style: "bold",
          sortable: false,
        },
        // { label: 'params.abbreviation', param: 'abbreviation', type: 'string' },
        { label: "params.abbreviation_23", param: "name_abre", type: "string" },
        {
          label: "params.top",
          param: "top",
          type: "boolean",
        },
        {
          label: "params.status",
          param: "status_event",
          type: "event_status",
          only_event: true,
          width: "150px",
          sortable: false,
        },
        {
          label: "params.inscription_date",
          param: "inscription_date",
          type: "date",
          only_event: true,
          width: "125px",
          sortable: false,
        },
        {
          type: "categories",
          label: "params.categories",
          param: "categories",
          only_event: true,
          width: "200px",
          sortable: false,
        },
        {
          label: "params.mic_gestor",
          param: "gestor_id",
          type: "user",
          only_event: true,
          width: "200px",
          sortable: false,
        },
        {
          label: "params.how_meet_present",
          param: "how_meet",
          type: "how_meet",
          only_event: true,
          width: "250px",
          sortable: false,
        },
        {
          label: "params.phone",
          param: "phone",
          type: "string",
          width: "200px",
          sortable: false,
        },
        {
          label: "params.mail",
          param: "mail",
          type: "string",
          width: "300px",
          sortable: false,
        },
        {
          label: "params.country",
          param: "country_id",
          type: "country",
          width: "100px",
          sortable: false,
        },
        {
          label: "params.address",
          param: "address",
          type: "string",
          width: "200px",
          fixed: true,
          sortable: false,
        },
        {
          label: "params.city",
          param: "city",
          type: "string",
          sortable: false,
        },
        { label: "params.cp", param: "cp", type: "string", sortable: false },
        {
          label: "params.state",
          param: "state",
          type: "string",
          sortable: false,
        },
        {
          label: "params.status",
          param: "status",
          type: "status",
          only_global: true,
          sortable: false,
        },
      ],
      filters: [
        {
          param: "name",
          label: "params.name",
          type: "string",
          current_value: "",
        },
        {
          param: "gestor_id",
          label: "params.mic_gestor",
          type: "select",
          only_event: true,
          options: "user/getListFilters",
          current_value: "{USER_ID}",
          translate: false,
        },
        {
          param: "phone",
          label: "params.phone",
          type: "string",
          current_value: "",
        },
        {
          param: "top",
          label: "params.top",
          type: "select",
          options: "getYesNo",
          current_value: -1,
        },
        {
          param: "mail",
          label: "params.mail",
          type: "string",
          current_value: "",
        },
        {
          param: "status_event",
          label: "params.status",
          type: "select",
          options: "events/getStatusEntities",
          params: { entity: 1 },
          only_event: true,
        },
        {
          param: "how_meet",
          label: "params.how_meet_present",
          type: "select",
          options: "getHowMeet",
          // params: { entity: 1 },
          only_event: true,
        },
        {
          param: "country_id",
          label: "params.country",
          type: "autocomplete",
          options: "getCountries",
          current_value: -1,
          translate: false,
        },
        {
          param: "status",
          label: "params.active",
          only_global: true,
          type: "check",
          current_value: 1,
        },
      ],
      default_filters: {
        country: -1,
        status: 1,
        gestor_id: "{USER_ID}",
      },
    },
    clubs_add: {
      label: "Crear club",
      url: "/club/add",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        { label: "params.shield", param: "shield", type: "image" },
        {
          label: "params.name",
          param: "name",
          type: "string",
          rules: [(value) => !!value || "Required."],
          uppercase: true,
        },
        {
          label: "params.abbreviation",
          param: "abbreviation",
          type: "string",
          rules: [(value) => !value || value.length == 3 || "3 characters"],
          uppercase: true,
        },
        {
          label: "params.abbreviation_23",
          param: "name_abre",
          type: "string",
          rules: [(value) => !value || value.length <= 23 || "23 characters"],
        },
        { label: "params.top", param: "top", type: "check" },
        { label: "params.phone", param: "phone", type: "string", rules: [] },
        { label: "params.mail", param: "mail", type: "string", rules: [] },
        { label: "params.web", param: "web", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "autocomplete",
          getter: "getCountries",
        },
        { label: "params.active", param: "status", type: "check" },
        {
          label: "params.mic_gestor",
          param: "gestor_id",
          type: "select",
          options: "user/getList",
          only_event: true,
        },
      ],
      parent_id: "clubs",
    },
    clubs_edit: {
      label: "Editar club",
      url: "/club/edit",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        { label: "params.shield", param: "shield", type: "image" },
        {
          label: "params.name",
          param: "name",
          type: "string",
          width: "200px",
          rules: [(value) => !!value || "Required."],
          uppercase: true,
        },
        {
          label: "params.abbreviation",
          param: "abbreviation",
          width: "50px",
          type: "string",
          rules: [(value) => !value || value.length == 3 || "3 characters"],
          uppercase: true,
        },
        {
          label: "params.abbreviation_23",
          param: "name_abre",
          type: "string",
          rules: [(value) => !value || value.length <= 23 || "23 characters"],
        },
        { label: "params.top", param: "top", type: "check" },
        { label: "params.phone", param: "phone", type: "string", rules: [] },
        { label: "params.mail", param: "mail", type: "string", rules: [] },
        { label: "params.web", param: "web", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "autocomplete",
          options: "getCountries",
        },
        { label: "params.active", param: "status", type: "check" },
        {
          label: "params.mic_gestor",
          param: "gestor_id",
          type: "select",
          options: "user/getList",
          only_event: true,
        },
        { label: "params.tax_id", param: "tax_id", type: "string", event_type_id: '15' },
        { label: "params.tax_name", param: "tax_name", type: "string", event_type_id: '15' },
        { label: "params.tax_address", param: "tax_address", type: "string", event_type_id: '15' },
      ],
      parent_id: "clubs_card",
    },
    clubs_card: {
      label: "Fitxa club",
      url: "/club/card/:id",
      actions: {
        main: {
          label: "Editar",
          url: "/club/edit/:id",
        },
        other: [
          {
            label: "remove",
            action: "remove",
          },
          {
            label: "notes.create",
            action: "create_note",
          },
          {
            label: "clubs.add_event",
            action: "rel_club_event",
            only_global: true,
          },
          {
            label: "clubs.user_zonaequipos",
            action: "user_create",
            only_event: true,
          },
          {
            label: "clubs.mic_preview_teamzone",
            action: "preview_teamzone",
            only_event: true,
          },
        ],
      },
      parent_id: "clubs",
    },
    teams: {
      label: "params.team",
      url: "/team",
      actions: {
        main: {
          label: "Equip",
          url: "/event/:event/team/add",
        },
        other: [
          {
            label: "Exportar",
            action: "export",
            type: "list",
          },
          {
            label: "Exportar assegurats",
            action: "export",
            type: "insurance",
          },
          {
            label: "Exportar Gestors",
            action: "export",
            type: "gestor",
          },
          {
            label: "Exportar uniformes",
            action: "export",
            type: "uniforms",
          },
          {
            label: "Exportar credencials",
            action: "export",
            type: "credentials",
          },
          {
            label: "teams.send_image_right",
            action: "teams_send_image_right",
            only_event: true,
          },
          {
            label: "Exportar actes",
            action: "starters"
          },
        ],
      },
      columns: [
        { label: "params.club", param: "club", type: "club", width: "150px" },
        {
          label: "params.name",
          param: "name",
          type: "string",
          width: "150px",
          style: "bold",
        },
        { label: "params.abbreviation_23", param: "name_abre", type: "string" },
        {
          label: "params.category",
          param: "category",
          type: "category",
          width: "75px",
        },
        {
          label: "params.mic_gestor",
          param: "club",
          type: "team_user",
          width: "175px",
        },
        {
          label: "params.status",
          param: "status",
          type: "event_status",
          width: "150px",
        },
        {
          label: "params.image_right",
          param: "image_right",
          type: "string",
          width: "150px",
          style: "bold",
        },
        {
          label: "params.last_image_right_update",
          param: "last_image_right_update",
          type: "date_hour",
          width: "150px",
        },
        { label: "params.mode", param: "mode", type: "mode", width: "100px" },
        {
          label: "hotels.label",
          param: "rooming",
          type: "rooming_hotel",
          width: "250px",
        },
        {
          label: "finances.to_pay",
          param: "budget",
          type: "budget_total",
          width: "125px",
        },
        {
          label: "finances.import_payed",
          param: "budget",
          type: "budget_payed",
          width: "125px",
        },
        {
          label: "finances.import_pendent",
          param: "budget",
          type: "budget_pay",
          width: "125px",
        },
        {
          label: "finances.pass_pay",
          param: "budget",
          type: "budget_passpay",
          width: "125px",
        },
        {
          label: "params.estimate_players",
          param: "estimate_players",
          type: "number",
          width: "125px",
        },
        {
          label: "params.estimate_staff",
          param: "estimate_staff",
          type: "number",
          width: "125px",
        },
        {
          label: "params.estimate_acompanyants",
          param: "estimate_acompanyants",
          type: "number",
          width: "125px",
        },
        {
          label: "params.registered_players",
          param: "registered_players",
          type: "number",
          width: "125px",
        },
        {
          label: "params.coefficient_age",
          param: "coefficient",
          type: "number",
          width: "125px",
        },
        {
          label: "params.registered_staff",
          param: "registered_staff",
          type: "number",
          width: "125px",
        },
        {
          label: "params.registered_acompanyants",
          param: "registered_acompanyants",
          type: "number",
          width: "125px",
        },
        // { label: 'params.payment', param: 'payment', type: 'payment' },
        {
          label: "params.insured",
          param: "insured",
          type: "insured",
          width: "200px",
        },
        {
          label: "campus.bus",
          param: "transfer",
          type: "boolean",
          width: "100px",
        },
        {
          label: "params.invited",
          param: "invited",
          type: "boolean",
          width: "100px",
        },
        { label: "params.state", param: "state", type: "string" },
        {
          label: "params.country",
          param: "club.country",
          type: "country",
          width: "100px",
        },
        {
          label: "params.team_division",
          param: "division_id",
          type: "division_id",
          width: "125px",
        },
        {
          label: "params.team_group",
          param: "division_group",
          type: "string",
          width: "125px",
        },
        {
          label: "params.finals",
          param: "finals",
          type: "insured",
          width: "200px",
        },
        {
          label: "params.finals_saturday",
          param: "finals_saturday",
          type: "insured",
          width: "200px",
        },
        {
          label: "params.opening",
          param: "opening",
          type: "insured",
          width: "200px",
        },
        {
          label: "transfer.bus_service_type",
          param: "transfer_options",
          type: "bus_service_type",
          width: "150px",
        },
      ],
      filters: [
        {
          param: "name",
          label: "params.name",
          type: "string",
          current_value: "",
        },
        // { param: 'country_id', label: 'params.country', type: 'autocomplete', options: 'getCountries', current_value: -1, translate: false },
        {
          param: "gestor_id",
          label: "params.mic_gestor",
          type: "select",
          only_event: true,
          options: "user/getListFilters",
          current_value: "{USER_ID}",
          translate: false,
        },
        {
          param: "status",
          label: "params.status",
          type: "select",
          options: "events/getStatusEntities",
          params: { entity: 2 },
        },
        {
          param: "mode",
          label: "params.mode",
          type: "select",
          options: "getModeRegistered",
        },
        {
          param: "image_right",
          label: "titles.image-rights",
          type: "select",
          options: "teams/getStatusDocuments",
          current_value: -1,
        },
        {
          param: "category",
          label: "params.category",
          type: "select",
          options: "events/getCategoriesEventSelected",
          current_value: -1,
        },
        {
          param: "division_id",
          label: "params.team_division",
          type: "select",
          options: "getTeamDivision",
          params: "{CURRENT_EVENT_TYPE_ID}",
          current_value: -1,
        },
        {
          param: "insured",
          label: "params.insured",
          type: "select",
          options: [
            { value: "0", text: "nsnc" },
            { value: "1", text: "si" },
            { value: "2", text: "no" },
          ],
          current_value: -1,
        },
        {
          param: "finals",
          label: "params.finals",
          type: "select",
          options: [
            { value: "0", text: "nsnc" },
            { value: "1", text: "si" },
            { value: "2", text: "no" },
          ],
          current_value: -1,
        },
        {
          param: "finals_saturday",
          label: "params.finals_saturday",
          type: "select",
          options: [
            { value: "0", text: "nsnc" },
            { value: "1", text: "si" },
            { value: "2", text: "no" },
          ],
          current_value: -1,
        },
        {
          param: "opening",
          label: "params.opening",
          type: "select",
          options: [
            { value: "0", text: "nsnc" },
            { value: "1", text: "si" },
            { value: "2", text: "no" },
          ],
          current_value: -1,
        },
        {
          param: "bus_service_type",
          label: "transfer.bus_service_type",
          type: "select",
          options: [
            { value: "nsnc", text: "nsnc" },
            { value: "no", text: "transfer.no_bus_service" },
            { value: "arrival", text: "transfer.bus_arrival_only" },
            { value: "departure", text: "transfer.bus_departure_only" },
            { value: "both", text: "transfer.bus_arrival_departure" },
            { value: "other", text: "transfer.bus_other_days" },
          ],
          current_value: -1,
        },
      ],
      default_filters: {
        status: -1,
        category: -1,
        gestor_id: "{USER_ID}",
      },
      submenus: [
        // { id: 1, name: 'categories', label: 'teams.categories', url: '/team' },
        // { id: 2, name: 'reports', label: 'teams.reports', url: '/team/report' }
      ],
      parent_id: "home",
    },
    teams_report: {
      label: "teams.report",
      url: "/team/report",
      actions: {
        main: {
          label: "Crear equip",
          url: "/event/:event/team/add",
        },
        other: [
          {
            label: "Exportar",
            action: "export",
            type: "list",
          },
        ],
      },
      parent_id: "teams",
      columns: [],
      filters: [],
      default_filters: {},
      submenus: [
        { id: 1, name: "categories", label: "teams.categories", url: "/team" },
        { id: 2, name: "reports", label: "teams.reports", url: "/team/report" },
      ],
    },
    teams_card: {
      label: "Fitxa equip",
      url: "/team/card/:id",
      actions: {
        main: {
          label: "Editar",
          url: "/event/:event/team/edit/:id",
        },
        other: [
          {
            label: "remove",
            action: "remove",
          },
          {
            label: "notes.create",
            action: "create_note",
          },
          // {
          //     label: "user.create",
          //     action: "user_create",
          //     only_event: true
          // },
          {
            label: "teams.send_image_right",
            action: "send_image_right",
            only_event: true,
          },
          {
            label: "teams.mic_preview_teamzone",
            action: "preview_teamzone",
            only_event: true,
          },
          {
            label: "teams.export_starters",
            action: "export_starters",
            only_event: true,
          },
          {
            label: "teams.print_myteams",
            action: "print_myteams",
            only_event: true,
          },
          {
            label: "volunteers.mic_assign_team_to_volunteer",
            action: "mic_assign_team_to_volunteer",
          },
        ],
      },
      parent_id: "teams",
    },
    teams_add: {
      label: "Crear equip",
      url: "/team/add",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        {
          label: "params.club",
          param: "club_id",
          type: "autocomplete",
          action: "clubs/loadList",
          getter: "clubs/getList",
        },
        {
          label: "params.name",
          param: "name",
          type: "string",
          uppercase: true,
        },
        {
          label: "params.abbreviation_23",
          param: "name_abre",
          type: "string",
          rules: [(value) => !value || value.length <= 23 || "23 characters"],
        },
        {
          label: "params.category",
          param: "category_id",
          type: "select",
          options: "events/getCategoriesEventSelected",
          rules: [
            (value) => !!value || "Required.",
            (value) => value != -1 || "Sel·lecciona una categoria valida",
          ],
        },
        {
          label: "params.estimate_players",
          param: "estimate_players",
          type: "number",
        },
        {
          label: "params.estimate_staff",
          param: "estimate_staff",
          type: "number",
        },
        {
          label: "params.estimate_acompanyants",
          param: "estimate_acompanyants",
          type: "number",
        },
        {
          label: "params.visible",
          param: "visible",
          type: "check",
          options: [],
        },
        {
          label: "params.insured",
          param: "insured",
          type: "select",
          options: "teams/getInsuredOptions",
        },
        {
          label: "params.opening",
          param: "opening",
          type: "select",
          options: "teams/getInsuredOptions",
        },
        {
          label: "params.finals",
          param: "finals",
          type: "select",
          options: "teams/getInsuredOptions",
        },
        {
          label: "params.finals_saturday",
          param: "finals_saturday",
          type: "select",
          options: "teams/getInsuredOptions",
        },
        {
          label: "params.invited",
          param: "invited",
          type: "check",
          options: [],
        },
        {
          label: "params.mode",
          param: "mode",
          type: "select",
          options: "getModeRegistered",
        },
        {
          label: "params.how_meet",
          param: "how_meet_id",
          type: "select",
          options: "getHowMeet",
          translate: true,
        },
        {
          label: "params.status",
          param: "status",
          type: "select",
          options: "events/getStatusEntities",
          params: { entity: 2 },
        },
        {
          label: "params.team_division",
          param: "division_id",
          type: "select",
          options: "getTeamDivision",
          translate: true,
        },
        {
          label: "params.team_group",
          param: "division_group",
          type: "string",
        },
      ],
      parent_id: "teams",
    },
    teams_edit: {
      label: "Editar equip",
      url: "/team/edit",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        {
          label: "params.club",
          param: "club_id",
          type: "autocomplete",
          action: "clubs/loadList",
          getter: "clubs/getList",
          disabled: true,
        },
        {
          label: "params.name",
          param: "name",
          type: "string",
          uppercase: true,
        },
        {
          label: "params.abbreviation_23",
          param: "name_abre",
          type: "string",
          rules: [(value) => !value || value.length <= 23 || "23 characters"],
        },
        {
          label: "params.category",
          param: "category_id",
          type: "select",
          options: "events/getCategoriesEventSelected",
          rules: [(value) => !!value || "Required."],
        },
        {
          label: "params.estimate_players",
          param: "estimate_players",
          type: "integer",
        },
        {
          label: "params.estimate_staff",
          param: "estimate_staff",
          type: "integer",
        },
        {
          label: "params.estimate_acompanyants",
          param: "estimate_acompanyants",
          type: "integer",
        },
        {
          label: "params.visible",
          param: "visible",
          type: "check",
          options: [],
        },
        {
          label: "params.insured",
          param: "insured",
          type: "select",
          options: "teams/getInsuredOptions",
        },
        {
          label: "params.opening",
          param: "opening",
          type: "select",
          options: "teams/getInsuredOptions",
        },
        {
          label: "params.finals",
          param: "finals",
          type: "select",
          options: "teams/getInsuredOptions",
        },
        {
          label: "params.finals_saturday",
          param: "finals_saturday",
          type: "select",
          options: "teams/getInsuredOptions",
        },
        {
          label: "params.invited",
          param: "invited",
          type: "check",
          options: [],
        },
        {
          label: "params.mode",
          param: "mode",
          type: "select",
          options: "getModeRegistered",
        },
        {
          label: "params.how_meet",
          param: "how_meet_id",
          type: "select",
          options: "getHowMeet",
          translate: true,
        },
        {
          label: "params.status",
          param: "status",
          type: "select",
          options: "events/getStatusEntities",
          params: { entity: 2 },
        },
        {
          label: "params.team_division",
          param: "division_id",
          type: "select",
          options: "getTeamDivision",
          translate: true,
        },
        {
          label: "params.team_group",
          param: "division_group",
          type: "string",
        },
      ],
      parent_id: "teams_card",
    },
    events: {
      label: "events.label",
      url: "/event",
      actions: {
        main: {
          label: "events.create.label",
          url: "/event/add",
          visible: false,
        },
        // other: [
        //     {
        //         label: 'Exportar',
        //         action: 'export',
        //         type: 'list'
        //     }
        // ],
      },
      parent_id: "home",
      columns: [
        {
          label: "params.logo",
          param: "logo",
          type: "logo_event",
          width: "100px",
          sortable: false,
          fixed: true,
        },
        { label: "params.name", param: "name", type: "string" },
        { label: "params.edition", param: "edition", type: "string" },
        { label: "params.start_date", param: "start_date", type: "date" },
        { label: "params.end_date", param: "end_date", type: "date" },
        { label: "params.teams", param: "teams", type: "string" },
        { label: "params.participants", param: "participants", type: "string" },
        { label: "params.status", param: "status", type: "status" },
      ],
      filters: [
        // {
        //   param: "name",
        //   label: "params.name",
        //   type: "string",
        //   current_value: ""
        // },
        {
          param: "event_type",
          label: "params.type",
          type: "select",
          options: "events/getEventType",
          current_value: "",
        },
        {
          param: "edition",
          label: "params.edition",
          type: "select",
          options: "events/getEditions",
          current_value: "",
        },
      ],
      default_filters: {},
    },
    persons: {
      label: "persons.label",
      url: "/person",
      actions: {
        main: {
          label: "person",
          url: "/person/add",
        },
        other: [
          {
            label: "Exportar",
            action: "export",
            type: "list",
          },
        ],
      },
      parent_id: "home",
      columns: [
        { label: "params.name", param: "name", type: "string", width: "150px" },
        {
          label: "params.surname",
          param: "surname",
          type: "string",
          width: "200px",
          style: "bold",
        },
        {
          label: "params.type",
          param: "contact_type",
          type: "role",
          width: "150px",
        },
        {
          label: "params.entity",
          param: "entity",
          type: "entity",
          width: "250px",
        },
        {
          label: "params.dni",
          param: "dni",
          type: "string",
          width: "200px",
          style: "bold",
        },
        {
          label: "params.email",
          param: "email",
          type: "string",
          width: "200px",
        },
        { label: "params.phone", param: "phone", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "country",
          width: "100px",
        },
        {
          label: "params.nacionality",
          param: "nacionality",
          type: "country",
          width: "100px",
        },
      ],
      filters: [
        {
          param: "name",
          label: "params.name",
          type: "string",
          current_value: "",
        },
        {
          param: "surname",
          label: "params.surname",
          type: "string",
          current_value: "",
        },
        {
          param: "dni",
          label: "params.dni",
          type: "string",
          current_value: "",
        },
        {
          param: "email",
          label: "params.email",
          type: "string",
          current_value: "",
        },
        {
          param: "phone",
          label: "params.phone",
          type: "string",
          current_value: "",
        },
        {
          param: "contact_type",
          label: "params.type",
          type: "select",
          options: "persons/getContactTypes",
          current_value: -1,
          current_value: "",
        },
        {
          param: "country_id",
          label: "params.country",
          type: "autocomplete",
          options: "getCountries",
          current_value: -1,
          translate: false,
        },
        {
          param: "nacionality",
          label: "params.nacionality",
          type: "autocomplete",
          options: "getCountries",
          current_value: -1,
          translate: false,
        },
        {
          param: "status",
          label: "params.status",
          type: "check",
          current_value: 1,
        },
      ],
      default_filters: {
        status: 1,
      },
      submenus: [
        {
          id: 1,
          name: "competition",
          label: "persons.competition",
          url: "/person/competition",
          // columns: [
          //     { label: 'params.name', param: 'name', type: 'string' },
          //     { label: 'params.dni', param: 'dni', type: 'string' },
          //     { label: 'params.email', param: 'email', type: 'string' },
          //     { label: 'params.phone', param: 'phone', type: 'string' },
          //     { label: 'params.address', param: 'address', type: 'string' },
          //     { label: 'params.city', param: 'city', type: 'string' },
          //     { label: 'params.cp', param: 'cp', type: 'string' },
          //     { label: 'params.state', param: 'state', type: 'string' },
          //     { label: 'params.country', param: 'country_id', type: 'country', width: "100px" },
          //     { label: 'params.nacionality', param: 'nacionality', type: 'country', width: "100px" },
          //     { label: 'params.type', param: 'contact_type', type: 'role' },
          //     { label: 'params.entity', param: 'entity', type: 'entity' },
          // ],
          filters: [],
          default_filters: {},
        },
        // {
        //     id: 2,
        //     name: 'staff',
        //     label: 'persons.staff',
        //     url: '/person/staff',
        //     // columns: [
        //     //     { label: 'params.name', param: 'name', type: 'string' },
        //     //     { label: 'params.dni', param: 'dni', type: 'string' },
        //     //     { label: 'params.email', param: 'email', type: 'string' },
        //     //     { label: 'params.phone', param: 'phone', type: 'string' },
        //     //     { label: 'params.address', param: 'address', type: 'string' },
        //     //     { label: 'params.city', param: 'city', type: 'string' },
        //     //     { label: 'params.cp', param: 'cp', type: 'string' },
        //     //     { label: 'params.state', param: 'state', type: 'string' },
        //     //     { label: 'params.country', param: 'country_id', type: 'country', width: "100px" },
        //     //     { label: 'params.nacionality', param: 'nacionality', type: 'country', width: "100px" },
        //     //     { label: 'params.type', param: 'contact_type', type: 'role' },
        //     //     { label: 'params.entity', param: 'entity', type: 'entity' },
        //     // ],
        //     filters: [

        //     ],
        //     default_filters: {
        //     }
        // },
        // {
        //     id: 3,
        //     name: 'logistic',
        //     label: 'persons.logistic',
        //     url: '/person/logistic',
        //     columns: [
        //         { label: 'params.name', param: 'name', type: 'string' },
        //         { label: 'params.dni', param: 'dni', type: 'string' },
        //         { label: 'params.email', param: 'email', type: 'string' },
        //         { label: 'params.phone', param: 'phone', type: 'string' },
        //         { label: 'params.address', param: 'address', type: 'string' },
        //         { label: 'params.city', param: 'city', type: 'string' },
        //         { label: 'params.cp', param: 'cp', type: 'string' },
        //         { label: 'params.state', param: 'state', type: 'string' },
        //         { label: 'params.country', param: 'country_id', type: 'country', width: "100px" },
        //         { label: 'params.nacionality', param: 'nacionality', type: 'country', width: "100px" },
        //         { label: 'params.type', param: 'contact_type', type: 'role' },
        //         { label: 'params.entity', param: 'entity', type: 'entity' },
        //     ],
        //     filters: [

        //     ],
        //     default_filters: {
        //     }
        // },
        {
          id: 4,
          name: "leads",
          label: "persons.leads",
          url: "/person/leads",
          only_event: true,
          columns: [
            { label: "params.name", param: "name", type: "string" },
            { label: "params.dni", param: "dni", type: "string" },
            { label: "params.email", param: "email", type: "string" },
            { label: "params.b_news", param: "b_news", type: "boolean" },
            { label: "params.language", param: "lang", type: "lang" },
            { label: "params.phone", param: "phone", type: "string" },
            { label: "params.address", param: "address", type: "string" },
            { label: "params.city", param: "city", type: "string" },
            { label: "params.cp", param: "cp", type: "string" },
            { label: "params.state", param: "state", type: "string" },
            {
              label: "params.country",
              param: "country_id",
              type: "country",
              width: "100px",
            },
            {
              label: "params.nacionality",
              param: "nacionality",
              type: "country",
              width: "100px",
            },
          ],
          filters: [],
          default_filters: {},
        },
      ],
    },
    persons_card: {
      label: "persons.card.label",
      url: "/person/card/:id",
      actions: {
        main: {
          label: "Editar",
          url: "/person/edit/:id",
          visible: false,
        },
        other: [
          {
            label: "remove",
            action: "remove",
          },
          {
            label: "notes.create",
            action: "create_note",
          },
          {
            label: "create_relationship",
            action: "create_relationship",
          },
        ],
      },
      parent_id: "persons",
    },
    persons_add: {
      label: "Crear persona",
      url: "/person/add",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // },
          {
            label: "Afegir nou rol",
            action: "add_role",
          },
        ],
      },
      params: [
        {
          label: "params.name",
          param: "name",
          type: "string",
          uppercase: true,
        },
        { label: "params.dni", param: "dni", type: "string", uppercase: true },
        { label: "params.email", param: "email", type: "string" },
        { label: "params.phone", param: "phone", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "autocomplete",
          options: "getCountries",
        },
        {
          label: "params.nacionality",
          param: "nacionality",
          type: "autocomplete",
          options: "getCountries",
        },
        { label: "params.active", param: "status", type: "check" },
      ],
      parent_id: "persons",
    },
    persons_edit: {
      label: "Editar persona",
      url: "/person/edit",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // },
          {
            label: "Afegir nou rol",
            action: "add_role",
          },
        ],
      },
      params: [
        {
          label: "params.name",
          param: "name",
          type: "string",
          uppercase: true,
        },
        { label: "params.dni", param: "dni", type: "string", uppercase: true },
        { label: "params.email", param: "email", type: "string" },
        { label: "params.phone", param: "phone", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "autocomplete",
          options: "getCountries",
        },
        {
          label: "params.nacionality",
          param: "nacionality",
          type: "autocomplete",
          options: "getCountries",
        },
        { label: "params.active", param: "status", type: "check" },
      ],

      parent_id: "persons_card",
    },
    persons_role_edit: {
      label: i18n.t("role.edit"),
      url: "/person/edit/:id/:type/:role_id",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [],
      },
      types: {
        staff: {
          params: [
            {
              label: "params.cargo",
              param: "contact_type_id",
              type: "select",
              options: "persons/getContactTypes",
              params: 2,
            },
            {
              label: "params.level",
              param: "nivel",
              type: "select",
              options: "getStaffLevel",
            },
            {
              label: "params.authoritzation",
              param: "authoritzation",
              type: "check",
            },
          ],
        },
        player: {
          params: [
            {
              label: "params.position",
              param: "position",
              type: "select",
              options: "persons/getPositions",
            },
            {
              label: "params.number",
              param: "number",
              type: "integer",
              rules: [
                (value) => !!value || "Required.",
                (value) =>
                  (value > 0 && value < 100) ||
                  "El dorsal ha d'estar compres entre 0 i 99",
              ],
            },
            { label: "params.altura", param: "altura", type: "integer" },
            {
              label: "params.authoritzation",
              param: "authoritzation",
              type: "check",
            },
            {
              label: "params.need_medicamento",
              param: "b_medicamento",
              type: "check",
            },
            {
              label: "params.medicamento",
              param: "medicamento",
              type: "textarea",
            },
            { label: "params.swim", param: "swim", type: "check" },
            { label: "params.active", param: "status", type: "check" },
          ],
        },
        manager: {
          params: [
            {
              label: "params.cargo",
              param: "contact_type_id",
              type: "select",
              options: "persons/getContactTypes",
              params: 1,
            },
            {
              label: "params.authoritzation",
              param: "authoritzation",
              type: "check",
            },
          ],
        },
        team: {
          params: [
            {
              label: "params.cargo",
              param: "contact_type_id",
              type: "select",
              options: "persons/getContactTypes",
              params: 2,
            },
            {
              label: "params.authoritzation",
              param: "authoritzation",
              type: "check",
            },
          ],
        },
      },
      parent_id: "persons_card",
    },
    volunteers: {
      label: "volunteers.label",
      url: "/volunteer",
      actions: {
        main: {
          label: "volunteers.create.label",
          url: "/volunteer/add",
          visible: false,
        },
        other: [
          {
            label: "Exportar",
            action: "export",
            type: "list",
          },
          {
            label: "Enviar mail nou document",
            action: "mail_document",
            type: "new",
          },
        ],
      },
      parent_id: "home",
      columns: [
        {
          label: "params.name",
          param: "name",
          type: "string",
          width: "150px",
          fixed: true,
        },
        {
          label: "params.surname",
          param: "surname",
          type: "string",
          width: "200px",
          style: "bold",
        },
        {
          label: "params.dni",
          param: "dni",
          type: "string",
          width: "125px",
          style: "bold",
        },
        {
          label: "params.phone",
          param: "phone",
          type: "string",
          width: "150px",
        },
        {
          label: "params.email",
          param: "email",
          type: "string",
          width: "150px",
        },
        {
          label: "params.city",
          param: "city",
          type: "string",
          width: "250px",
        },
        {
          label: "last_update",
          param: "user_modify",
          type: "last_update",
          width: "200px",
        },
        {
          label: "params.status",
          param: "status",
          type: "event_status",
          width: "175px",
          only_event: true,
        },
        {
          label: "params.language",
          param: "idiomas",
          type: "idiomas",
          width: "200px",
        },
        {
          label: "params.years_on_mic",
          param: "years_mic",
          type: "number",
          width: "100px",
          only_event: true,
        },
        {
          label: "params.day_of_arrival",
          param: "day_of_arrival",
          type: "date",
          width: "150px",
          only_event: true,
        },
        {
          label: "params.day_of_exit",
          param: "day_of_exit",
          type: "date",
          width: "150px",
          only_event: true,
        },
        {
          label: "params.take_car",
          param: "have_car",
          type: "boolean",
          width: "100px",
          only_event: true,
        },
        {
          label: "params.car_seats",
          param: "car_seats",
          type: "integer",
          width: "100px",
          only_event: true,
        },
        {
          label: "params.alergy",
          param: "alergy",
          type: "allergy",
          width: "150px",
          only_event: true,
        },
        {
          label: "params.other_allergies",
          param: "other_allergies",
          type: "string",
          width: "150px",
          only_event: true,
        },
        {
          label: "params.diet",
          param: "diet",
          type: "diet",
          width: "150px",
          only_event: true,
        },
        {
          label: "params.clothing_size",
          param: "shirt_size",
          type: "shirt_size",
          width: "100px",
          only_event: true,
        },
        {
          label: "params.shoes_size",
          param: "shoes_size",
          type: "shoes_size",
          width: "100px",
          only_event: true,
        },
        {
          label: "params.observations",
          param: "observations",
          type: "string",
          width: "250px",
          only_event: true,
        },
        {
          label: "params.event",
          param: "event",
          type: "events_name",
          width: "100px",
          only_global: true,
        },
        {
          label: "params.event",
          param: "event",
          type: "events_work",
          width: "300px",
          only_global: true,
        },
      ],
      filters: [
        {
          param: "name",
          label: "params.name",
          type: "string",
          current_value: "",
        },
        {
          param: "surname",
          label: "params.surname",
          type: "string",
          current_value: "",
        },
        {
          param: "dni",
          label: "params.dni",
          type: "string",
          current_value: "",
        },
        {
          param: "status",
          label: "params.status",
          type: "select",
          options: "events/getStatusEntities",
          params: { entity: 30 },
          current_value: -1,
        },
        {
          param: "idiomas",
          label: "params.language",
          type: "select",
          options: "getLanguageVolunteerFullname",
          current_value: -1,
        },
        {
          param: "email",
          label: "params.email",
          type: "string",
          current_value: "",
        },
        {
          param: "car_seats",
          label: "params.car_seats",
          type: "string",
          current_value: "",
          only_event: true,
        },
        {
          param: "event",
          label: "params.event",
          type: "select",
          options: "events/getEventEditions",
          current_value: -1,
          current_value: "",
          only_global: true,
        },
        {
          param: "phone",
          label: "params.phone",
          type: "string",
          current_value: "",
        },
      ],
      default_filters: {
        status: 1,
        event: -1,
      },
    },
    volunteers_card: {
      label: "volunteers.card.label",
      url: "/volunteer/card/:id",
      actions: {
        main: {
          label: "Editar",
          url: "/volunteer/edit/:id",
          visible: false,
        },
        other: [
          {
            label: "remove",
            action: "remove",
          },
          {
            label: "notes.create",
            action: "create_note",
          },
          {
            label: "volunteers.add_event",
            action: "rel_volunteer_event",
            only_global: true,
          },
          {
            label: "volunteers.mic_preview",
            action: "mic_preview",
          },
          {
            label: "volunteers.mic_assign_team",
            action: "mic_assign_team",
            only_event: true,
          },
        ],
      },
      parent_id: "volunteers",
    },
    volunteers_add: {
      label: "volunteers.create.label",
      url: "/volunteer/add",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        { label: "params.username", param: "username", type: "string" },
        { label: "params.name", param: "name", type: "string" },
        { label: "params.password", param: "password", type: "password" },
        { label: "params.email", param: "email", type: "string" },
      ],
      parent_id: "volunteers",
    },
    // 'volunteers_edit': {
    //     label: 'volunteers.edit.label',
    //     url: '/volunteer/edit',
    //     actions: {
    //         main: {
    //             label: 'save',
    //             action: 'save'
    //         },
    //         other: [
    //             // {
    //             //     label: 'Exportar',
    //             //     action: ''
    //             // }
    //         ],
    //     },
    //     params: [
    //         { label: 'params.username', param: 'username', type: 'string' },
    //         { label: 'params.name', param: 'name', type: 'string' },
    //         { label: 'params.password', param: 'password', type: 'password' },
    //         { label: 'params.email', param: 'email', type: 'string' },
    //     ],
    //     parent_id: 'volunteers_card'
    // },
    user: {
      label: "user.label",
      url: "/user",
      actions: {
        main: {
          label: "user.create",
          url: "/user/add",
        },
        other: [
          {
            label: "Exportar",
            action: "export",
            type: "list",
          },
        ],
      },
      parent_id: "home",
      columns: [
        {
          label: "params.avatar",
          param: "avatar",
          type: "default_image",
          width: "100px",
          sortable: false,
          fixed: true,
        },
        { label: "params.name", param: "name", type: "string", fixed: true },
        { label: "params.email", param: "email", type: "string" },
        { label: "params.username", param: "username", type: "string" },
        { label: "params.type", param: "type", type: "user_bo_type" },
        {
          label: "params.status",
          param: "status",
          type: "user_mic_status",
          width: "100px",
          sortable: false,
        },
      ],
      filters: [
        {
          param: "name",
          label: "params.name",
          type: "string",
          current_value: "",
        },
        {
          param: "type",
          label: "params.type",
          type: "select",
          options: [{ text: "Tots", value: -1 }].concat(USER_BO_TYPE_OPTIONS),
          current_value: -1,
        },
        {
          param: "status",
          label: "params.status",
          type: "check",
          current_value: 1,
        },
      ],
      default_filters: {
        status: 1,
      },
    },
    user_card: {
      label: "user.card.label",
      url: "/user/card/:id",
      actions: {
        main: {
          label: "Editar",
          url: "/user/edit/:id",
        },
        other: [
          {
            label: "user.activate",
            action: "activate_user",
          },
          {
            label: "user.deactivate",
            action: "deactivate_user",
          },
          {
            label: "remove",
            action: "remove",
          },
          {
            label: "notes.create",
            action: "create_note",
          },
          {
            label: "create_relationship",
            action: "create_relationship",
          },
        ],
      },
      parent_id: "user",
    },
    user_add: {
      label: "Crear usuari",
      url: "/user/add",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        {
          label: "params.type",
          param: "type",
          type: "select",
          options: USER_BO_TYPE_OPTIONS,
        },
        { label: "params.username", param: "username", type: "string" },
        { label: "params.name", param: "name", type: "string" },
        { label: "params.email", param: "email", type: "string" },
        { label: "params.password", param: "password", type: "password" },
      ],
      parent_id: "user",
    },
    user_edit: {
      label: "Editar usuari",
      url: "/user/edit",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        {
          label: "params.type",
          param: "type",
          type: "select",
          options: USER_BO_TYPE_OPTIONS,
        },
        { label: "params.username", param: "username", type: "string" },
        { label: "params.name", param: "name", type: "string" },
        { label: "params.email", param: "email", type: "string" },
        { label: "params.password", param: "password", type: "password" },
      ],
      parent_id: "user_card",
    },
    finances: {
      label: "finances.label",
      url: "/finances",
      actions: {
        main: {
          label: "finances.import.label",
          action: "click",
          type: "excel",
          visible: false,
        },
        other: [],
      },
      parent_id: "home",
      columns: [
        { label: "params.date", param: "date", type: "date" },
        { label: "params.affair", param: "affair", type: "string" },
        { label: "params.import", param: "import", type: "import" },
        { label: "params.type", param: "type", type: "payment" },
        { label: "params.status", param: "payed", type: "status_transaction" },
      ],
      filters: [
        /* { param: 'date', label: 'params.date', type: 'string', current_value: "" }, */
        {
          param: "affair",
          label: "params.affair",
          type: "string",
          current_value: "",
        },
        {
          param: "import",
          label: "params.import",
          type: "string",
          current_value: "",
        },
        {
          param: "type",
          label: "params.type",
          type: "select",
          options: "finances/getTransactionTypes",
          current_value: "",
        },
        {
          param: "payed",
          label: "params.status",
          type: "select",
          options: "finances/getTransactionStates",
          current_value: 0,
        },
      ],
      default_filters: {
        payed: 0,
      },
      submenus: [
        // {
        //   id: 1,
        //   name: "finances",
        //   label: "finances.transactions",
        //   url: "/finances",
        //   selected: true
        // },
        {
          id: 1,
          name: "payments",
          label: "finances.payments.label",
          url: "/finances/payments",
        },
        {
          id: 3,
          name: "prices",
          label: "finances.prices.label",
          url: "/finances/prices",
        },
        {
          id: 4,
          name: "discounts",
          label: "finances.discounts.label",
          url: "/finances/discounts",
        },
      ],
    },
    finances_payments: {
      label: "finances.label",
      url: "/finances/payments",
      actions: {
        main: {
          label: "Exportar",
          action: "export",
          type: "list",
        },
        other: [],
      },
      parent_id: "home",
      columns: [
        { label: "params.date", param: "date", type: "date" },
        { label: "params.affair", param: "affair", type: "string" },
        { label: "params.import", param: "import", type: "import" },
        { label: "params.entity", param: "entity", type: "entity" },
        { label: "params.mode", param: "mode", type: "string_translate" },
        // { label: 'params.status', param: 'payed', type: 'status_transaction' },
      ],
      filters: [
        /* { param: 'date', label: 'params.date', type: 'string', current_value: "" }, */
        // { param: 'affair', label: 'params.affair', type: 'string', current_value: "" },
        {
          param: "import",
          label: "params.import",
          type: "string",
          current_value: "",
        },
      ],
      submenus: [
        // {
        //   id: 1,
        //   name: "finances",
        //   label: "finances.transactions",
        //   url: "/finances"
        // },
        {
          id: 1,
          name: "payments",
          label: "finances.payments.label",
          url: "/finances/payments",
          selected: true,
        },
        {
          id: 3,
          name: "prices",
          label: "finances.prices.label",
          url: "/finances/prices",
        },
        {
          id: 4,
          name: "discounts",
          label: "finances.discounts.label",
          url: "/finances/discounts",
        },
      ],
    },
    finances_prices: {
      label: "finances.prices.label",
      url: "/finances/prices",
      actions: {
        main: {
          label: "finances.prices.export.label",
          action: "click",
          type: "excel",
          visible: false,
        },
        other: [],
      },
      parent_id: "home",
      columns: [
        { label: "params.name", param: "name", type: "string_translate" },
        {
          label: "params.description",
          param: "description",
          type: "string_translate",
        },
        { label: "params.category", param: "type", type: "price_category" },
        { label: "params.import", param: "import", type: "import" },
        // { label: 'params.entity', param: 'entity', type: 'entity' },
        // { label: 'params.mode', param: 'mode', type: 'string_translate' },
        // { label: 'params.status', param: 'payed', type: 'status_transaction' },
      ],
      filters: [
        {
          param: "import",
          label: "params.import",
          type: "string",
          current_value: "",
        },
        {
          param: "status",
          label: "params.active",
          type: "check",
          current_value: 1,
        },
      ],
      default_filters: {
        status: 1,
      },
      submenus: [
        // {
        //   id: 1,
        //   name: "finances",
        //   label: "finances.transactions",
        //   url: "/finances"
        // },
        {
          id: 1,
          name: "payments",
          label: "finances.payments.label",
          url: "/finances/payments",
        },
        {
          id: 3,
          name: "prices",
          label: "finances.prices.label",
          url: "/finances/prices",
          selected: true,
        },
        {
          id: 4,
          name: "discounts",
          label: "finances.discounts.label",
          url: "/finances/discounts",
        },
      ],
    },
    finances_discounts: {
      label: "finances.discounts.label",
      url: "/finances/discounts",
      actions: {
        main: {
          label: "finances.discounts.export.label",
          action: "click",
          type: "excel",
          visible: false,
        },
        other: [],
      },
      parent_id: "home",
      columns: [
        { label: "params.name", param: "name", type: "string_translate" },
        {
          label: "params.description",
          param: "description",
          type: "string_translate",
        },
        { label: "params.category", param: "type", type: "price_category" },
        { label: "params.import", param: "value", type: "import" },
        { label: "params.code", param: "code", type: "string" },
        // { label: 'params.entity', param: 'entity', type: 'entity' },
        // { label: 'params.mode', param: 'mode', type: 'string_translate' },
        // { label: 'params.status', param: 'payed', type: 'status_transaction' },
      ],
      filters: [
        {
          param: "import",
          label: "params.import",
          type: "string",
          current_value: "",
        },
        {
          param: "status",
          label: "params.active",
          type: "check",
          current_value: 1,
        },
      ],
      default_filters: {
        status: 1,
      },
      submenus: [
        // {
        //   id: 1,
        //   name: "finances",
        //   label: "finances.transactions",
        //   url: "/finances"
        // },
        {
          id: 1,
          name: "payments",
          label: "finances.payments.label",
          url: "/finances/payments",
        },
        {
          id: 3,
          name: "prices",
          label: "finances.prices.label",
          url: "/finances/prices",
        },
        {
          id: 4,
          name: "discounts",
          label: "finances.discounts.label",
          url: "/finances/discounts",
          selected: true,
        },
      ],
    },
    finances_add: {
      label: "finances.import.label",
      url: "/finances/add",
      parent_id: "finances",
      actions: {
        main: {
          label: "finances.import.save_import",
          action: "save",
        },
        other: [],
      },
    },
    documentation: {
      label: "documentation.label",
      url: "/documentation",
      parent_id: "home",
      actions: {
        main: {
          label: "documentation.import.label",
          url: "/documentation/add",
        },
        other: [],
      },
    },
    documentation_add: {
      label: "documentation.import.label",
      url: "/documentation/add",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [],
      },
      params: [
        {
          label: "params.file",
          param: "file",
          type: "file",
          rules: [
            (value) =>
              !value ||
              value.size < 2000000 ||
              "Avatar size should be less than 2 MB!",
          ],
        },
        {
          label: "params.name",
          param: "name",
          type: "string",
          rules: [(value) => !!value || "Required."],
        },
        { label: "params.tags", param: "tags", type: "tags" },
        {
          label: "params.page",
          param: "pages",
          type: "select",
          multiple: true,
          options: "documentation/getPages",
          rules: [(value) => !!value || "Required"],
        },
      ],
      parent_id: "documentation",
    },
    documentation_edit: {
      label: "documentation.edit.label",
      url: "/documentation/edit",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [],
      },
      params: [
        { label: "params.file", param: "file", type: "file" },
        {
          label: "params.name",
          param: "name",
          type: "string",
          rules: [(value) => !!value || "Required."],
        },
        { label: "params.tags", param: "tags", type: "tags" },
        {
          label: "params.page",
          param: "pages",
          type: "select",
          multiple: true,
          options: "documentation/getPages",
          rules: [(value) => !!value || "Required"],
        },
      ],
      parent_id: "documentation",
    },
    participants: {
      label: "participants.label",
      url: "/participants",
      actions: {
        main: {
          label: "participants.create.label",
          url: "/participants/add",
          visible: false,
        },
        other: [
          {
            label: "Exportar",
            action: "export",
            type: "list",
          },
          {
            label: "Exportar peticions hab.",
            action: "export",
            type: "campus_rooms",
          },
          {
            label: "Exportar grups entrenament",
            action: "export",
            type: "campus_training",
          },
          {
            label: "Enviar mail nou document",
            action: "mail_document",
            type: "new",
          },
        ],
      },
      parent_id: "home",
      columns: [
        { label: "params.name", param: "name", type: "string", width: "200px" },
        {
          label: "params.surname",
          param: "surname",
          type: "string",
          width: "300px",
        },
        {
          label: "campus.code",
          param: "campus_code",
          type: "campus_code",
          width: "150px",
        },
        { label: "params.dni", param: "dni", type: "string", width: "200px" },
        {
          label: "campus.bus",
          param: "bus",
          type: "bus_campus",
          width: "150px",
        },
        {
          label: "titles.external",
          param: "pickup",
          type: "bus_campus_pickup",
          width: "225px",
        },
        {
          label: "titles.returnit",
          param: "returnit",
          type: "bus_campus_pickup",
          width: "225px",
        },
        {
          label: "params.birthday",
          param: "birthday",
          type: "date",
          width: "150px",
        },
        {
          label: "params.status",
          param: "status",
          type: "event_status",
          width: "400px",
        },
        {
          label: "params.status_participant",
          param: "status_participant",
          type: "participant_status",
          width: "400px",
        },
        {
          label: "campus.inscription_date",
          param: "inscription_date",
          type: "date",
          width: "150px",
        },
        {
          label: "campus.finances",
          param: "budget",
          type: "campus_finances",
          width: "300px",
        },
        {
          label: "campus.lottery_name",
          param: "lottery",
          type: "boolean",
          width: "80px",
        },
        {
          label: "campus.lottery_send",
          param: "lottery_send",
          type: "lottery_send",
          width: "150px",
        },
        {
          label: "titles.image-rights",
          param: "image_right",
          type: "document",
          width: "150px",
        },
        {
          label: "campus.participate",
          param: "campus",
          type: "campus",
          width: "300px",
        },
        {
          label: "params.email",
          param: "email",
          type: "string",
          width: "200px",
        },
        { label: "params.phone", param: "phone", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "country",
          width: "100px",
        },
        {
          label: "params.nacionality",
          param: "nacionality",
          type: "country",
          width: "100px",
        },
        {
          label: "params.language",
          param: "lang",
          type: "lang",
          width: "200px",
        },
        {
          label: "params.position",
          param: "campus_position",
          type: "campus_position",
          width: "200px",
        },
      ],
      filters: [
        {
          param: "name",
          label: "params.name",
          type: "string",
          current_value: "",
        },
        {
          param: "surname",
          label: "params.surname",
          type: "string",
          current_value: "",
        },
        // { param: 'dni', label: 'params.dni', type: 'string', current_value: "" },
        {
          param: "email",
          label: "params.email",
          type: "string",
          current_value: "",
        },
        // { param: 'phone', label: 'params.phone', type: 'string', current_value: "" },
        {
          param: "campus_type",
          label: "campus.participate",
          type: "select",
          options: "events/getCampusNameEventSelected",
          current_value: -1,
        },
        {
          param: "campus_date",
          label: "turn",
          type: "select",
          options: "events/getCampusDatesEventSelected",
          current_value: -1,
        },
        {
          param: "campus_modality",
          label: "campus.modality",
          type: "select",
          options: [
            { text: "campus.modality", value: -1 },
            { text: "campus.intern", value: 1 },
            { text: "campus.extern", value: 2 },
          ],
          current_value: -1,
        },
        {
          param: "bus",
          label: "campus.bus",
          type: "select",
          options: "getBusTypes",
          current_value: -1,
        },
        {
          param: "pickup",
          label: "titles.external",
          type: "select",
          options: "getPickUpOptions",
          current_value: -1,
        },
        {
          param: "returnit",
          label: "titles.returnit",
          type: "select",
          options: "getPickUpOptions",
          current_value: -1,
        },
        { param: "lottery", label: "campus.lottery_name", type: "check" },
        { param: "lottery_send", label: "campus.lottery_send", type: "check" },
        {
          param: "image_right",
          label: "titles.image-rights",
          type: "select",
          options: "persons/getStatusDocuments",
          current_value: -1,
        },
        {
          param: "medicines",
          label: "titles.medicines",
          type: "select",
          options: "persons/getStatusDocuments",
          current_value: -1,
        },
        {
          param: "antithermal",
          label: "titles.antithermal",
          type: "select",
          options: "persons/getStatusDocuments",
          current_value: -1,
        },
        {
          param: "vaccination",
          label: "titles.vaccination",
          type: "select",
          options: "persons/getStatusDocuments",
          current_value: -1,
        },
        {
          param: "medic_card",
          label: "titles.medic-card",
          type: "select",
          options: "persons/getStatusDocuments",
          current_value: -1,
        },
        {
          param: "status",
          label: "params.status",
          type: "select",
          options: "events/getStatusEntities",
          params: { entity: 10 },
          current_value: -1,
        },
        {
          param: "status_participant",
          label: "params.status_participant",
          type: "select",
          options: "getStatusParticipants",
          current_value: -1,
        },
      ],
      default_filters: {
        status: 1,
      },
    },
    participants_card: {
      label: "participants.card.label",
      url: "/person/card/:id",
      actions: {
        main: {
          label: "Editar",
          url: "/person/edit/:id",
          visible: false,
        },
        other: [
          {
            label: "remove",
            action: "remove",
          },
          {
            label: "notes.create",
            action: "create_note",
          },
          {
            label: "assign_week",
            action: "assign_week",
          },
          {
            label: "participants.mic_preview_teamzone",
            action: "preview_teamzone",
            only_event: true,
          },
        ],
      },
      parent_id: "participants",
    },
    participants_add: {
      label: "Crear persona",
      url: "/person/add",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // },
          {
            label: "Afegir nou rol",
            action: "add_role",
          },
        ],
      },
      params: [
        {
          label: "params.name",
          param: "name",
          type: "string",
          uppercase: true,
        },
        { label: "params.dni", param: "dni", type: "string", uppercase: true },
        { label: "params.email", param: "email", type: "string" },
        { label: "params.phone", param: "phone", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "autocomplete",
          options: "getCountries",
        },
        {
          label: "params.nacionality",
          param: "nacionality",
          type: "autocomplete",
          options: "getCountries",
        },
        { label: "params.active", param: "status", type: "check" },
      ],
      parent_id: "participants",
    },
    participants_edit: {
      label: "Editar persona",
      url: "/person/edit",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // },
          {
            label: "Afegir nou rol",
            action: "add_role",
          },
        ],
      },
      params: [
        {
          label: "params.name",
          param: "name",
          type: "string",
          uppercase: true,
        },
        { label: "params.dni", param: "dni", type: "string", uppercase: true },
        { label: "params.email", param: "email", type: "string" },
        { label: "params.phone", param: "phone", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "autocomplete",
          options: "getCountries",
        },
        {
          label: "params.nacionality",
          param: "nacionality",
          type: "autocomplete",
          options: "getCountries",
        },
        { label: "params.active", param: "status", type: "check" },
      ],

      parent_id: "participants_card",
    },
    hotels: {
      label: "hotels.label",
      url: "/hotel",
      actions: {
        main: {
          label: "titles.hotel",
          url: "/hotel/add",
          only_global: true,
        },
        other: [
          {
            label: "Exportar",
            action: "export",
            type: "list",
          },
          {
            label: "Exportar Roomings",
            action: "export",
            type: "rooming_list",
          },
          {
            label: "hotels.rel_hotel_event",
            action: "rel_hotel_event",
            only_event: true,
          },
        ],
      },
      parent_id: "home",
      columns: [
        {
          label: "params.name",
          param: "name",
          type: "string",
          width: "300px",
          fixed: true,
          style: "bold",
        },
        {
          label: "params.category",
          param: "category",
          type: "hotel_category",
          width: "150px",
          fixed: true,
        },
        {
          label: "params.bussines",
          param: "bussines",
          type: "string",
          width: "100px",
          fixed: true,
        },
        {
          label: "params.city",
          param: "city",
          type: "string",
          width: "300px",
          fixed: true,
        },
        {
          label: "params.state",
          param: "state",
          type: "string",
          width: "300px",
          fixed: true,
        },
        {
          label: "hotels.rooms_short",
          param: "num_rooms",
          type: "room",
          width: "150px",
          fixed: true,
        },
        {
          label: "I pax",
          param: "num_rooms_1",
          type: "room",
          width: "200px",
          fixed: true,
        },
        {
          label: "II pax",
          param: "num_rooms_2",
          type: "room",
          width: "200px",
          fixed: true,
        },
        {
          label: "III pax",
          param: "num_rooms_3",
          type: "room",
          width: "200px",
          fixed: true,
        },
        {
          label: "IV pax",
          param: "num_rooms_4",
          type: "room",
          width: "200px",
          fixed: true,
        },
        {
          label: "V pax",
          param: "num_rooms_5",
          type: "room",
          width: "200px",
          fixed: true,
        },
        {
          label: "params.phone",
          param: "phone",
          type: "string",
          width: "300px",
        },
        {
          label: "params.phone2",
          param: "phone2",
          type: "string",
          width: "300px",
        },
        { label: "params.email", param: "email", type: "string" },
        { label: "params.bussines", param: "bussines", type: "string" },
        {
          label: "params.status",
          param: "status",
          type: "status",
          width: "300px",
        },
      ],
      filters: [
        {
          param: "name",
          label: "params.name",
          type: "string",
          current_value: "",
        },
        {
          param: "city",
          label: "params.city",
          type: "string",
          current_value: "",
        },
        {
          param: "state",
          label: "params.state",
          type: "string",
          current_value: "",
        },
        {
          param: "category",
          label: "params.category",
          type: "select",
          options: "hotels/getCategories",
          current_value: "",
          translate: true,
        },
        {
          param: "bussines",
          label: "params.bussines",
          type: "string",
          current_value: "",
        },
        // {
        //   param: "status",
        //   label: "params.status",
        //   type: "check",
        //   current_value: 1
        // }
      ],
      default_filters: {
        status: 1,
      },
    },
    hotels_card: {
      label: "hotels.card.label",
      url: "/hotel/card/:id",
      actions: {
        main: {
          label: "Editar",
          url: "/hotel/edit/:id",
        },
        other: [
          {
            label: "Exportar Rooming",
            action: "export_rooming",
            only_event: true,
          },
          {
            label: "hotels.add_event",
            action: "rel_hotel_event",
            only_global: true,
          },
          {
            label: "remove",
            action: "remove",
          },
          {
            label: "notes.create",
            action: "create_note",
          },
        ],
      },
      parent_id: "hotels",
    },
    hotels_add: {
      label: "hotels.create.label",
      url: "/hotel/add",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        { label: "params.name", param: "name", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "autocomplete",
          getter: "getCountries",
        },
        {
          label: "params.category",
          param: "category",
          type: "select",
          options: "hotels/getCategories",
          rules: [(value) => !!value || "Required"],
        },
        { label: "params.bussines", param: "bussines", type: "string" },
        { label: "params.nif", param: "nif", type: "string" },
        { label: "params.phone", param: "phone", type: "string" },
        { label: "params.phone2", param: "phone2", type: "string" },
        { label: "params.web", param: "web", type: "string" },
        { label: "params.email", param: "email", type: "string" },
        { label: "params.halal", param: "halal", type: "check", options: [] },
        { label: "params.pc_halal", param: "pc_halal", type: "string" },
        { label: "params.picnic", param: "picnic", type: "check", options: [] },
        { label: "params.pc_picnic", param: "pc_picnic", type: "string" },
        {
          label: "params.extra_meal",
          param: "extra_meal",
          type: "check",
          options: [],
        },
        {
          label: "params.pc_extra_meal",
          param: "pc_extra_meal",
          type: "string",
        },
        {
          label: "params.parking",
          param: "parking",
          type: "check",
          options: [],
        },
        { label: "params.pc_parking", param: "pc_parking", type: "string" },
        {
          label: "params.bressol",
          param: "bressol",
          type: "check",
          options: [],
        },
        { label: "params.pc_bressol", param: "pc_bressol", type: "string" },
        {
          label: "params.late_checkout",
          param: "late_checkout",
          type: "check",
          options: [],
        },
        {
          label: "params.pc_late_checkout",
          param: "pc_late_checkout",
          type: "string",
        },
        { label: "params.buffet", param: "buffet", type: "check", options: [] },
        {
          label: "params.dining_capacity",
          param: "dining_capacity",
          type: "string",
        },
        { label: "params.rooms", param: "rooms", type: "check", options: [] },
        { label: "params.gym", param: "gym", type: "check", options: [] },
        { label: "params.pool", param: "pool", type: "check", options: [] },
        {
          label: "params.observations",
          param: "observations",
          type: "textarea",
        },
      ],
      parent_id: "hotels",
    },
    hotels_edit: {
      label: "hotels.edit.label",
      url: "/hotel/edit",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        { label: "params.name", param: "name", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "autocomplete",
          getter: "getCountries",
        },
        {
          label: "params.category",
          param: "category",
          type: "select",
          options: "hotels/getCategories",
          rules: [(value) => !!value || "Required"],
        },
        { label: "params.bussines", param: "bussines", type: "string" },
        { label: "params.nif", param: "nif", type: "string" },
        { label: "params.phone", param: "phone", type: "string" },
        { label: "params.phone2", param: "phone2", type: "string" },
        { label: "params.web", param: "web", type: "string" },
        { label: "params.email", param: "email", type: "string" },
        { label: "params.halal", param: "halal", type: "check", options: [] },
        { label: "params.pc_halal", param: "pc_halal", type: "string" },
        { label: "params.picnic", param: "picnic", type: "check", options: [] },
        { label: "params.pc_picnic", param: "pc_picnic", type: "string" },
        {
          label: "params.extra_meal",
          param: "extra_meal",
          type: "check",
          options: [],
        },
        {
          label: "params.pc_extra_meal",
          param: "pc_extra_meal",
          type: "string",
        },
        {
          label: "params.parking",
          param: "parking",
          type: "check",
          options: [],
        },
        { label: "params.pc_parking", param: "pc_parking", type: "string" },
        {
          label: "params.bressol",
          param: "bressol",
          type: "check",
          options: [],
        },
        { label: "params.pc_bressol", param: "pc_bressol", type: "string" },
        {
          label: "params.late_checkout",
          param: "late_checkout",
          type: "check",
          options: [],
        },
        {
          label: "params.pc_late_checkout",
          param: "pc_late_checkout",
          type: "string",
        },
        { label: "params.buffet", param: "buffet", type: "check", options: [] },
        {
          label: "params.dining_capacity",
          param: "dining_capacity",
          type: "string",
        },
        { label: "params.rooms", param: "rooms", type: "check", options: [] },
        { label: "params.gym", param: "gym", type: "check", options: [] },
        { label: "params.pool", param: "pool", type: "check", options: [] },
        {
          label: "params.observations",
          param: "observations",
          type: "textarea",
        },
      ],
      parent_id: "hotels_card",
    },
    facilitys: {
      label: "facilitys.label",
      url: "/facility",
      actions: {
        main: {
          label: "params.facility",
          url: "/facility/add",
        },
        other: [
          {
            label: "Exportar",
            action: "export",
            type: "list",
          },
        ],
      },
      parent_id: "home",
      columns: [
        {
          label: "params.name",
          param: "name",
          type: "string",
          width: "200px",
          fixed: true,
          style: "bold",
        },
        {
          label: "params.name_competition",
          param: "name_competition",
          type: "string",
          width: "200px",
          fixed: true,
        },
        {
          label: "params.city",
          param: "city",
          type: "string",
          width: "200px",
          fixed: true,
        },
        {
          label: "params.state",
          param: "state",
          type: "string",
          width: "200px",
          fixed: true,
        },
        {
          label: "params.phone",
          param: "phone",
          type: "string",
          width: "200px",
        },
        {
          label: "params.email",
          param: "email",
          type: "string",
          width: "200px",
        },
      ],
      filters: [
        {
          param: "name",
          label: "params.name",
          type: "string",
          current_value: "",
        },
        {
          param: "city",
          label: "params.city",
          type: "string",
          current_value: "",
        },
        {
          param: "status",
          label: "params.status",
          type: "check",
          current_value: 1,
        },
      ],
      default_filters: {
        status: 1,
      },
    },
    facilitys_card: {
      label: "facilitys.card.label",
      url: "/facility/card/:id",
      actions: {
        main: {
          label: "Editar",
          url: "/facility/edit/:id",
        },
        other: [
          {
            label: "facilitys.add_event",
            action: "rel_facility_event",
            only_global: true,
          },
          {
            label: "remove",
            action: "remove",
          },
          {
            label: "notes.create",
            action: "create_note",
          },
        ],
      },
      parent_id: "facilitys",
    },
    facilitys_add: {
      label: "facilitys.create.label",
      url: "/facility/add",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        { label: "params.name", param: "name", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "autocomplete",
          getter: "getCountries",
        },
        { label: "params.phone", param: "phone", type: "string" },
        { label: "params.phone2", param: "phone2", type: "string" },
        { label: "params.web", param: "web", type: "string" },
        { label: "params.email", param: "email", type: "string" },
        {
          label: "params.activities",
          param: "activities",
          type: "autocomplete",
          getter: "getCountries",
        },
        { label: "params.spectators", param: "spectators", type: "string" },
        {
          label: "params.megafonia",
          param: "megafonia",
          type: "check",
          options: [],
        },
        { label: "params.wifi", param: "wifi", type: "check", options: [] },
        {
          label: "params.parking",
          param: "parking",
          type: "check",
          options: [],
        },
        {
          label: "params.infirmary",
          param: "infirmary",
          type: "check",
          options: [],
        },
        { label: "params.grada", param: "grada", type: "check", options: [] },
        {
          label: "params.grada_type",
          param: "grada_type",
          type: "select",
          options: ["Descoberta", "Coberta", "Ambdós"],
        },
        {
          label: "params.illumination",
          param: "illumination",
          type: "check",
          options: [],
        },
        { label: "params.bar", param: "bar", type: "check", options: [] },
        {
          label: "params.defibrillator",
          param: "defibrillator",
          type: "check",
          options: [],
        },
        {
          label: "params.closed_perimeter",
          param: "closed_perimeter",
          type: "check",
          options: [],
        },
        {
          label: "params.warmup_zone",
          param: "warmup_zone",
          type: "check",
          options: [],
        },
        { label: "params.latitud", param: "latitud", type: "string" },
        { label: "params.longitud", param: "longitud", type: "string" },
      ],
      parent_id: "facilitys",
    },
    facilitys_edit: {
      label: "facilitys.edit.label",
      url: "/facility/edit",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        { label: "params.name", param: "name", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "autocomplete",
          getter: "getCountries",
        },
        { label: "params.phone", param: "phone", type: "string" },
        { label: "params.phone2", param: "phone2", type: "string" },
        { label: "params.web", param: "web", type: "string" },
        { label: "params.email", param: "email", type: "string" },
        {
          label: "params.activities",
          param: "activities",
          type: "select",
          options: [
            { text: "football", value: 1 },
            { text: "other", value: 0 },
          ],
        },
        { label: "params.spectators", param: "spectators", type: "string" },
        {
          label: "params.megafonia",
          param: "megafonia",
          type: "check",
          options: [],
        },
        { label: "params.wifi", param: "wifi", type: "check", options: [] },
        {
          label: "params.parking",
          param: "parking",
          type: "check",
          options: [],
        },
        {
          label: "params.infirmary",
          param: "infirmary",
          type: "check",
          options: [],
        },
        { label: "params.grada", param: "grada", type: "check", options: [] },
        {
          label: "params.grada_type",
          param: "grada_type",
          type: "select",
          options: ["Descoberta", "Coberta", "Ambdós"],
        },
        {
          label: "params.illumination",
          param: "illumination",
          type: "check",
          options: [],
        },
        { label: "params.bar", param: "bar", type: "check", options: [] },
        {
          label: "params.defibrillator",
          param: "defibrillator",
          type: "check",
          options: [],
        },
        {
          label: "params.closed_perimeter",
          param: "closed_perimeter",
          type: "check",
          options: [],
        },
        {
          label: "params.warmup_zone",
          param: "warmup_zone",
          type: "check",
          options: [],
        },
        { label: "params.latitud", param: "latitud", type: "string" },
        { label: "params.longitud", param: "longitud", type: "string" },
      ],
      parent_id: "facilitys_card",
    },
    travels: {
      label: "travels.label",
      url: "/travel",
      actions: {
        main: {
          label: "travels.travel",
          url: "/travel/add",
        },
        other: [
          {
            label: "Exportar",
            action: "export",
            type: "list",
          },
        ],
      },
      parent_id: "home",
      columns: [
        {
          label: "params.identifier",
          param: "travel_number",
          width: "100px",
          fixed: true,
        },
        {
          label: "params.n_pax",
          param: "people",
          type: "pax",
          width: "300px",
          fixed: true,
        },
        { label: "params.n_pax", param: "pax", width: "100px" },
        {
          label: "params.transport_company",
          param: "transport_company",
          width: "150px",
          fixed: true,
        },
        {
          label: "params.transport_number",
          param: "transport_number",
          width: "150px",
          fixed: true,
        },
        {
          label: "params.bus_private",
          param: "bus_private",
          type: "boolean",
          width: "100px",
        },
        {
          label: "params.type",
          param: "type",
          type: "travel_type",
          width: "150px",
          fixed: true,
        },
        {
          label: "params.origin_date",
          param: "origin.date",
          type: "string",
          width: "200px",
        },
        {
          label: "params.origin_hour",
          param: "origin.hour",
          type: "string",
          width: "200px",
        },
        {
          label: "params.origin",
          param: "origin",
          type: "location",
          width: "200px",
        },
        {
          label: "params.destination_date",
          param: "destination.date",
          type: "string",
          width: "200px",
        },
        {
          label: "params.destination_hour",
          param: "destination.hour",
          type: "string",
          width: "200px",
        },
        {
          label: "params.destination",
          param: "destination",
          type: "location",
          width: "200px",
        },

        {
          label: "params.transport_mode",
          param: "transport_mode",
          type: "transport_mode",
          width: "100px",
        },

        { label: "params.cost", param: "cost", width: "100px" },
        { label: "params.contact_name", param: "contact_name", width: "100px" },
        {
          label: "params.contact_phone",
          param: "contact_phone",
          width: "100px",
        },

        { label: "params.observations", param: "observations", width: "200px" },
        {
          label: "params.observations_int",
          param: "observations_int",
          width: "200px",
        },
      ],
      filters: [
        {
          param: "travel_number",
          label: "params.travel_number",
          type: "string",
          current_value: "",
        },
        {
          param: "travel_type",
          label: "params.type",
          type: "select",
          options: "travels/getTravelsType",
          current_value: "",
          translate: true,
        },
        // { param: 'type', label: 'params.type', type: 'multichoice', options: 'user/getList' },
        // { param: 'transport_mode', label: 'params.transport_mode', type: 'select', options: ['Bus', 'Avió', 'Tren'] },
        {
          param: "transport_number",
          label: "params.transport_number",
          type: "string",
          current_value: "",
        },
        {
          param: "club",
          label: "params.club",
          type: "autocomplete",
          only_event: true,
          options: "clubs/getList",
          translate: false,
        },
        {
          param: "team",
          label: "params.team",
          type: "autocomplete",
          only_event: true,
          options: "teams/getListWithCategory",
          translate: false,
        },
        {
          param: "gestor_id",
          label: "params.mic_gestor",
          type: "select",
          only_event: true,
          options: "user/getListFilters",
          current_value: "{USER_ID}",
          translate: false,
        },
        // { param: 'origin', label: 'params.origin', type: 'multichoice', options: 'user/getList' },
        // { param: 'destination', label: 'params.destination', type: 'multichoice', options: 'user/getList' },
        // { param: 'origin.date', label: 'params.date', type: 'date', options: 'user/getList' },
        // { param: 'gestor_id', label: 'params.gestor', type: 'multichoice', options: 'user/getList' },
        // { param: 'team', label: 'params.team', type: 'multichoice', options: 'user/getList' },
        // { param: 'participant', label: 'params.participant', type: 'multichoice', options: 'user/getList' },
        // {
        //   param: "status",
        //   label: "params.status",
        //   type: "check",
        //   current_value: 1
        // }
      ],
      default_filters: {
        // status: 1,
        gestor_id: "{USER_ID}",
      },
    },
    travels_card: {
      label: "travels.card.label",
      url: "/travel/card/:id",
      actions: {
        main: {
          label: "Editar",
          url: "/travel/edit/:id",
        },
        other: [
          {
            label: "remove",
            action: "remove",
          },
        ],
      },
      parent_id: "travels",
    },
    travels_add: {
      label: "travels.create.label",
      url: "/travel/add",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        { label: "params.name", param: "name", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "autocomplete",
          getter: "getCountries",
        },
        { label: "params.bussines", param: "bussines", type: "string" },
        { label: "params.nif", param: "nif", type: "string" },
        { label: "params.phone", param: "phone", type: "string" },
        { label: "params.phone2", param: "phone", type: "string" },
        { label: "params.web", param: "web", type: "string" },
        { label: "params.email", param: "email", type: "string" },
        { label: "params.halal", param: "halal", type: "check", options: [] },
        { label: "params.pc_halal", param: "pc_halal", type: "string" },
        { label: "params.picnic", param: "picnic", type: "check", options: [] },
        { label: "params.pc_picnic", param: "pc_picnic", type: "string" },
        {
          label: "params.extra_meal",
          param: "extra_meal",
          type: "check",
          options: [],
        },
        {
          label: "params.pc_extra_meal",
          param: "pc_extra_meal",
          type: "string",
        },
        {
          label: "params.parking",
          param: "parking",
          type: "check",
          options: [],
        },
        { label: "params.pc_parking", param: "pc_parking", type: "string" },
        {
          label: "params.bressol",
          param: "bressol",
          type: "check",
          options: [],
        },
        { label: "params.pc_bressol", param: "pc_bressol", type: "string" },
        {
          label: "params.late_checkout",
          param: "late_checkout",
          type: "check",
          options: [],
        },
        {
          label: "params.pc_late_checkout",
          param: "pc_late_checkout",
          type: "string",
        },
        { label: "params.buffet", param: "buffet", type: "check", options: [] },
        {
          label: "params.dining_capacity",
          param: "dining_capacity",
          type: "string",
        },
        { label: "params.rooms", param: "rooms", type: "check", options: [] },
        { label: "params.gym", param: "gym", type: "check", options: [] },
        { label: "params.pool", param: "pool", type: "check", options: [] },
        {
          label: "params.observations",
          param: "observations",
          type: "textarea",
        },
      ],
      parent_id: "travels",
    },
    travels_edit: {
      label: "travels.edit.label",
      url: "/travel/edit",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      params: [
        { label: "params.name", param: "name", type: "string" },
        { label: "params.city", param: "city", type: "string" },
        { label: "params.state", param: "state", type: "string" },
        { label: "params.address", param: "address", type: "string" },
        { label: "params.cp", param: "cp", type: "string" },
        {
          label: "params.country",
          param: "country_id",
          type: "autocomplete",
          getter: "getCountries",
        },
        { label: "params.bussines", param: "bussines", type: "string" },
        { label: "params.nif", param: "nif", type: "string" },
        { label: "params.phone", param: "phone", type: "string" },
        { label: "params.phone2", param: "phone", type: "string" },
        { label: "params.web", param: "web", type: "string" },
        { label: "params.email", param: "email", type: "string" },
        { label: "params.halal", param: "halal", type: "check", options: [] },
        { label: "params.pc_halal", param: "pc_halal", type: "string" },
        { label: "params.picnic", param: "picnic", type: "check", options: [] },
        { label: "params.pc_picnic", param: "pc_picnic", type: "string" },
        {
          label: "params.extra_meal",
          param: "extra_meal",
          type: "check",
          options: [],
        },
        {
          label: "params.pc_extra_meal",
          param: "pc_extra_meal",
          type: "string",
        },
        {
          label: "params.parking",
          param: "parking",
          type: "check",
          options: [],
        },
        { label: "params.pc_parking", param: "pc_parking", type: "string" },
        {
          label: "params.bressol",
          param: "bressol",
          type: "check",
          options: [],
        },
        { label: "params.pc_bressol", param: "pc_bressol", type: "string" },
        {
          label: "params.late_checkout",
          param: "late_checkout",
          type: "check",
          options: [],
        },
        {
          label: "params.pc_late_checkout",
          param: "pc_late_checkout",
          type: "string",
        },
        { label: "params.buffet", param: "buffet", type: "check", options: [] },
        {
          label: "params.dining_capacity",
          param: "dining_capacity",
          type: "string",
        },
        { label: "params.rooms", param: "rooms", type: "check", options: [] },
        { label: "params.gym", param: "gym", type: "check", options: [] },
        { label: "params.pool", param: "pool", type: "check", options: [] },
        {
          label: "params.observations",
          param: "observations",
          type: "textarea",
        },
      ],
      parent_id: "travels_card",
    },
    competition: {
      label: "competition.label",
      url: "/competition",
      actions: {
        main: {
          label: "Exportar calendari",
          action: "export",
          type: "calendar",
          visible: true,
        },
        other: [
          {
            label: "Exportar partits",
            action: "export",
            type: "matches",
            visible: true,
          },
        ],
      },
      parent_id: "home",
    },
    competition_groups: {
      label: "competition.group.label",
      url: "/competition/groups",
      actions: {
        main: {
          label: "Exportar",
          action: "export",
          type: "list",
          visible: true,
        },
        other: [],
      },
      display: {
        header: {
          visible: true,
        },
        footer: {
          visible: false,
        },
      },
      columns: [
        {
          label: "params.category",
          param: "category",
          type: "string",
          sortable: false,
          width: "100px",
        },
        {
          label: "params.group",
          param: "group",
          type: "string",
          sortable: false,
          width: "100px",
        },
        {
          label: "params.position",
          param: "name",
          type: "string",
          sortable: false,
          width: "100px",
          style: "bold",
        },
        {
          label: "params.team",
          param: "team",
          type: "assign_team",
          sortable: false,
          width: "75%",
          style: "bold",
        },
      ],
      filters: [
        {
          param: "category_id",
          label: "params.category",
          type: "select",
          options: "events/getCategoriesEventSelected",
          current_value: "{COMPETITION_CATEGORY_ID}",
          translate: false,
        },
      ],
      default_filters: {
        status: 1,
        category_id: "{COMPETITION_CATEGORY_ID}",
      },
      parent_id: "competition",
    },
    competition_calendar: {
      label: "competition.label",
      url: "/competition/matchs",
      actions: {
        main: {
          label: "",
          action: "click",
          type: "excel",
          visible: false,
        },
        other: [],
      },
      display: {
        header: {
          visible: true,
        },
        footer: {
          visible: false,
        },
      },
      columns: [
        {
          label: "params.category",
          param: "category",
          type: "string",
          sortable: false,
          width: "50px",
        },
        {
          label: "competition.phases.label",
          param: "name",
          type: "competition_phase",
          sortable: false,
          width: "95%",
        },
      ],
      filters: [
        {
          param: "category_id",
          label: "params.category",
          type: "select",
          options: "events/getCategoriesEventSelected",
          current_value: "{COMPETITION_CATEGORY_ID}",
          translate: false,
        },
      ],
      default_filters: {
        status: 1,
        category_id: "{COMPETITION_CATEGORY_ID}",
      },
      parent_id: "competition",
    },
    competition_matchs: {
      label: "competition.calendar.label",
      url: "/competition/matchs/:category_id/:phase_id",
      actions: {
        main: {
          label: "Exportar",
          action: "export",
          type: "list",
          visible: true,
        },
        other: [],
      },
      display: {
        header: {
          visible: true,
        },
        footer: {
          visible: false,
        },
      },
      columns: [
        {
          label: "params.category",
          param: "category",
          type: "string",
          sortable: false,
          width: "50px",
        },
        {
          label: "params.group",
          param: "group",
          type: "string_translate",
          sortable: false,
          width: "30px",
        },
        {
          label: "params.round",
          param: "round",
          type: "string_translate",
          sortable: true,
          width: "30px",
        },
        {
          label: "params.name",
          param: "name",
          type: "string",
          sortable: true,
          width: "60px",
          style: "bold",
        },
        {
          label: "params.date",
          param: "date",
          type: "date_hour",
          sortable: true,
          width: "100px",
        },
        {
          label: "params.status",
          param: "status",
          type: "status_match",
          sortable: true,
          width: "100px",
        },
        {
          label: "params.local_team",
          param: "local_team",
          type: "tmpl_team",
          sortable: false,
          width: "125px",
        },
        {
          label: "params.local_goals",
          param: "local_goals",
          type: "number",
          sortable: false,
          width: "30px",
          style: "bold",
        },
        {
          label: "params.local_penalty_goals",
          param: "local_penalti_goals",
          type: "number",
          sortable: false,
          width: "30px",
        },
        {
          label: "params.away_penalty_goals",
          param: "away_penalti_goals",
          type: "number",
          sortable: false,
          width: "30px",
        },
        {
          label: "params.away_goals",
          param: "away_goals",
          type: "number",
          sortable: false,
          width: "30px",
          style: "bold",
        },
        {
          label: "params.away_team",
          param: "away_team",
          type: "tmpl_team",
          sortable: false,
          width: "125px",
        },
        {
          label: "params.facility",
          param: "facility",
          type: "facility",
          sortable: true,
          width: "200px",
        },
      ],
      filters: [
        // {
        //   param: "category_id",
        //   label: "params.category",
        //   type: "select",
        //   options: "events/getCategoriesEventSelected",
        //   current_value: "{COMPETITION_CATEGORY_ID}",
        //   translate: false
        // },
        {
          param: "name",
          label: "params.name",
          type: "string",
        },
        // {
        //   param: "round_id",
        //   label: "params.round",
        //   type: "select",
        //   options: "competition/getListRoundsByCategoryID",
        //   params: "{COMPETITION_CATEGORY_ID}",
        //   current_value: -1
        // },
        {
          param: "status",
          label: "params.status",
          type: "select",
          options: "competition/matchs/getStatusMatch",
          current_value: "-1",
          translate: true,
        },
      ],
      default_filters: {
        status: -1,
        // category_id: "{COMPETITION_CATEGORY_ID}"
      },
      parent_id: "competition_calendar",
    },
    competition_matchs_edit: {
      label: "competition.calendar.edit.label",
      url: "/competition/matchs/:category_id/:phase_id/:id/edit",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          {
            label: "Anar a MIC Camps",
            action: "go_to_camps",
          },
        ],
      },
      parent_id: "competition_matchs",
    },
    competition_scoreboard: {
      label: "competition.label",
      url: "/competition/scoreboard",
      actions: {
        main: {
          label: "",
          action: "click",
          type: "excel",
          visible: false,
        },
        other: [],
      },
      display: {
        header: {
          visible: true,
        },
        footer: {
          visible: false,
        },
      },
      columns: [
        {
          label: "params.category",
          param: "category",
          type: "string",
          sortable: false,
          width: "100px",
        },
        {
          label: "competition.phases.label",
          param: "name",
          type: "string_translate",
          sortable: false,
          width: "95%",
        },
      ],
      filters: [
        {
          param: "category_id",
          label: "params.category",
          type: "select",
          options: "events/getCategoriesEventSelected",
          current_value: "{COMPETITION_CATEGORY_ID}",
          translate: false,
        },
      ],
      default_filters: {
        status: 1,
        category_id: "{COMPETITION_CATEGORY_ID}",
      },
      parent_id: "competition",
    },
    competition_scoreboard_phase: {
      label: "competition.label",
      url: "/competition/scoreboard/:phase_id",
      display: {
        header: {
          visible: true,
        },
        footer: {
          visible: false,
        },
      },
      actions: {
        main: {
          label: "",
          action: "click",
          type: "excel",
          visible: false,
        },
        other: [
          {
            label: "Generar playoff",
            action: "generate_playoff",
          },
        ],
      },
      columns: [
        {
          label: "params.position",
          param: "pos",
          type: "order",
          width: "100px",
        },
        {
          label: "params.shield",
          param: "shield",
          type: "image",
          width: "50px",
        },
        {
          label: "params.name",
          param: "name",
          type: "string",
          width: "200px",
          uppercase: true,
        },
        {
          label: "params.coefficient_age",
          param: "coefficient",
          type: "number",
          width: "90px",
        },
        {
          label: "params.points",
          param: "points",
          type: "number",
          width: "50px",
          style: "bold",
        },
        {
          label: "params.games_played",
          param: "gp",
          type: "number",
          width: "50px",
        },
        {
          label: "params.games_win",
          param: "gw",
          type: "number",
          width: "50px",
        },
        {
          label: "params.games_lost",
          param: "gl",
          type: "number",
          width: "50px",
        },
        {
          label: "params.games_tie",
          param: "gt",
          type: "number",
          width: "50px",
        },
        {
          label: "params.goals_f",
          param: "gof",
          type: "number",
          width: "50px",
        },
        {
          label: "params.goals_c",
          param: "goc",
          type: "number",
          width: "50px",
        },
        {
          label: "params.goals_diff",
          param: "god",
          type: "number",
          width: "50px",
        },
      ],
      filters: [
        {
          param: "category_id",
          label: "params.category",
          type: "select",
          options: "events/getCategoriesEventSelected",
          current_value: "{COMPETITION_CATEGORY_ID}",
          translate: false,
        },
      ],
      default_filters: {
        status: 1,
        category_id: "{COMPETITION_CATEGORY_ID}",
      },
      parent_id: "competition_scoreboard",
    },
    competition_stats: {
      label: "competition.stat.label",
      url: "/competition/stats",
      actions: {
        main: {
          label: "",
          action: "click",
          type: "excel",
          visible: false,
        },
        other: [],
      },
      parent_id: "competition",
    },
    competition_stats_top_scores: {
      label: "competition.stat.top_score.label",
      url: "/competition/stats/top_scores",
      actions: {
        main: {
          //   label: "",
          //   action: "click",
          //   type: "excel",
          visible: false,
        },
        other: [],
      },
      display: {
        header: {
          visible: true,
        },
        footer: {
          visible: false,
        },
      },
      columns: [
        {
          label: "params.name",
          param: "person_name",
          type: "string",
          width: "150px",
          sortable: false,
        },
        {
          label: "params.surname",
          param: "person_surname",
          width: "150px",
          type: "string",
          sortable: false,
        },
        {
          label: "miccamps.stats.goals",
          param: "goals",
          width: "50px",
          type: "number",
          sortable: false,
        },
        {
          label: "params.shield",
          param: "team_shield",
          type: "image",
          width: "30px",
          sortable: false,
        },
        {
          label: "params.team",
          param: "team_name",
          type: "string_translate",
          sortable: false,
          width: "300px",
          style: "bold",
        },
      ],
      filters: [
        {
          param: "category_id",
          label: "params.category",
          type: "select",
          options: "events/getCategoriesEventSelected",
          current_value: "{COMPETITION_CATEGORY_ID}",
          translate: false,
        },
      ],
      default_filters: {
        status: 1,
        category_id: "{COMPETITION_CATEGORY_ID}",
      },
      parent_id: "competition_stats",
    },
    competition_stats_team_scores: {
      label: "competition.stat.team_score.label",
      url: "/competition/stats/team_scores",
      actions: {
        main: {
          label: "",
          action: "click",
          type: "excel",
          visible: false,
        },
        other: [],
      },
      display: {
        header: {
          visible: true,
        },
        footer: {
          visible: false,
        },
      },
      columns: [
        {
          label: "params.shield",
          param: "shield",
          type: "image",
          sortable: false,
          width: "30px",
        },
        {
          label: "params.name",
          param: "name",
          type: "string_translate",
          sortable: false,
          width: "80%",
        },
        {
          label: "params.goals",
          param: "goals_f",
          type: "number",
          sortable: false,
        },
      ],
      filters: [
        {
          param: "category_id",
          label: "params.category",
          type: "select",
          options: "events/getCategoriesEventSelected",
          current_value: "{COMPETITION_CATEGORY_ID}",
          translate: false,
        },
      ],
      default_filters: {
        status: 1,
        category_id: "{COMPETITION_CATEGORY_ID}",
      },
      parent_id: "competition_stats",
    },
    competition_stats_top_goalkeepers: {
      label: "competition.stat.top_goalkeeper.label",
      url: "/competition/stats/top_goalkeepers",
      actions: {
        main: {
          label: "",
          action: "click",
          type: "excel",
          visible: false,
        },
        other: [],
      },
      columns: [
        {
          label: "params.name",
          param: "name",
          type: "string_translate",
          sortable: false,
        },
        {
          label: "params.goals",
          param: "goals",
          type: "number",
          sortable: false,
        },
        {
          label: "params.shield",
          param: "team_shield",
          type: "image",
          width: "100px",
        },
        {
          label: "params.name",
          param: "team_name",
          type: "string_translate",
          sortable: false,
        },
      ],
      filters: [
        {
          param: "category_id",
          label: "params.category",
          type: "select",
          options: "events/getCategoriesEventSelected",
          current_value: "{COMPETITION_CATEGORY_ID}",
          translate: false,
        },
      ],
      default_filters: {
        status: 1,
        category_id: "{COMPETITION_CATEGORY_ID}",
      },
      parent_id: "competition_stats",
    },
    competition_injuries: {
      label: "competition.injury.label",
      url: "/competition/injuries",
      actions: {
        main: {
          label: "Exportar",
          action: "export",
          type: "list",
        },
        other: [],
      },
      display: {
        header: {
          visible: true,
        },
        footer: {
          visible: false,
        },
      },
      columns: [
        {
          label: "params.name",
          param: "person_name",
          type: "string",
          width: "100px",
          sortable: false,
        },
        {
          label: "params.surname",
          param: "person_surname",
          width: "150px",
          type: "string",
          sortable: false,
        },
        {
          label: "params.type",
          param: "type",
          width: "100px",
          type: "string",
          sortable: false,
        },
        {
          label: "params.description",
          param: "comment",
          width: "300px",
          type: "string",
          sortable: false,
        },
        {
          label: "params.ambulance",
          param: "ambulance",
          width: "100px",
          type: "status",
          sortable: false,
        },
        {
          label: "params.match_name",
          param: "match_name",
          width: "100px",
          type: "string",
          sortable: false,
        },
        {
          label: "params.shield",
          param: "team_shield",
          type: "image",
          width: "75px",
          sortable: false,
        },
        {
          label: "params.team",
          param: "team_name",
          type: "string_translate",
          sortable: false,
        },
      ],
      filters: [
        {
          param: "category_id",
          label: "params.category",
          type: "select",
          options: "events/getCategoriesEventSelected",
          current_value: "{COMPETITION_CATEGORY_ID}",
          translate: false,
        },
      ],
      default_filters: {
        status: 1,
        category_id: "{COMPETITION_CATEGORY_ID}",
      },
      parent_id: "competition",
    },
    competition_sanctions: {
      label: "competition.sanction.label",
      url: "/competition/sanctions",
      display: {
        header: {
          visible: true,
        },
        footer: {
          visible: false,
        },
      },
      actions: {
        main: {
          label: "competition.sanction.add.label",
          action: "add_sanction",
          visible: true,
        },
        other: [
            {
                label: "Exportar",
                action: "export",
                type: "list",
            }
        ],
      },
      columns: [
        {
          label: "params.status",
          param: "status_sanction",
          type: "string",
          width: "150px",
          sortable: false,
        },
        {
          label: "params.name",
          param: "person_name",
          type: "string",
          width: "150px",
          sortable: false,
        },
        {
          label: "params.surname",
          param: "person_surname",
          width: "250px",
          type: "string",
          sortable: false,
        },
        {
          label: "params.match_name",
          param: "match_name",
          width: "100px",
          type: "string",
          sortable: false,
        },
        {
          label: "params.num_matches",
          param: "num_match",
          width: "100px",
          type: "number",
          sortable: false,
        },
        {
          label: "params.num_matches_completed",
          param: "matches_completed",
          width: "100px",
          type: "number",
          sortable: false,
        },
        {
          label: "params.type",
          param: "type",
          width: "100px",
          type: "string",
          sortable: false,
        },
        {
          label: "params.sanction",
          param: "sanctions_name",
          width: "400px",
          type: "string_translate",
          sortable: false,
        },
        {
          label: "params.shield",
          param: "team_shield",
          type: "image",
          width: "50px",
          sortable: false,
        },
        {
          label: "params.team",
          param: "team_name",
          type: "string_translate",
          sortable: false,
          width: "200px",
        },
      ],
      filters: [
        {
          param: "category_id",
          label: "params.category",
          type: "select",
          options: "events/getCategoriesEventSelected",
          current_value: "{COMPETITION_CATEGORY_ID}",
          translate: false,
        },
      ],
      default_filters: {
        status: 1,
        category_id: "{COMPETITION_CATEGORY_ID}",
      },
      parent_id: "competition",
    },
    competition_sanctions_edit: {
      label: "competition.sanction.edit.label",
      url: "/competition/sanctions/:id",
      actions: {
        main: {
          label: "save",
          action: "save",
        },
        other: [
          {
            label: "Desestimar",
            action: "sanction_desestimar",
          },
          {
            label: "Obrir fitxa partit",
            action: "go_to_match_edit",
          },
        ],
      },

      parent_id: "competition_sanctions",
    },
    settings: {
      label: "settings.label",
      url: "/settings",
      actions: {
        main: {
          label: "Guardar",
          action: "save",
        },
        other: [],
      },
      parent_id: "home",
    },
    confirmations: {
      label: "hotel_confirmations",
      url: "/confirmations",
      actions: {
        main: {
          label: "save",
          action: "save",
          visible: false,
        },
        other: [
          // {
          //     label: 'Exportar',
          //     action: ''
          // }
        ],
      },
      parent_id: "home",
      columns: [
        {
          label: "params.name",
          param: "name",
          type: "string",
          width: "300px",
          fixed: true,
          style: "bold",
        },
        {
            label: "params.category",
            param: "category",
            type: "category",
            width: "75px",
        },
        {
          label: "hotels.hotel_confirmations.team_list",
          param: "team_list_complete",
          type: "hotel_completion",
          width: "150px",
          fixed: true,
          style: "bold",
        },
        {
          label: "hotels.hotel_confirmations.rooming",
          param: "rooming_complete",
          type: "hotel_completion",
          width: "150px",
          fixed: true,
          style: "bold",
        },
        {
          label: "hotels.hotel_confirmations.profile_review",
          param: "profile_review_complete",
          type: "hotel_completion",
          width: "150px",
          fixed: true,
          style: "bold",
        },
        {
          label: "hotels.hotel_confirmations.gifts",
          param: "gifts_complete",
          type: "hotel_completion",
          width: "150px",
          fixed: true,
          style: "bold",
        },
      ],
      filters: [
        {
          param: "name",
          label: "params.name",
          type: "string",
          current_value: "",
        },
        {
            param: "category",
            label: "params.category",
            type: "select",
            options: "events/getCategoriesEventSelected",
            current_value: -1,
        },
        // { param: 'country_id', label: 'params.country', type: 'autocomplete', options: 'getCountries', current_value: -1, translate: false },
        {
          param: "gestor_id",
          label: "params.mic_gestor",
          type: "select",
          only_event: true,
          options: "user/getListFilters",
          current_value: "{USER_ID}",
          translate: false,
        },
        {
          param: "team_list_complete",
          label: "hotels.hotel_confirmations.team_list",
          type: "select",
          options: [
            { value: "0", text: "competition.sanction.status.pending" },
            { value: "1", text: "competition.sanction.status.completed" },
            { value: "2", text: "miccamps.match_actions.fail" },
          ],
          current_value: -1,
        },
        {
          param: "rooming_complete",
          label: "hotels.hotel_confirmations.rooming",
          type: "select",
          options: [
            { value: "1", text: "competition.sanction.status.completed" },
            { value: "0", text: "competition.sanction.status.pending" },
            { value: "2", text: "miccamps.match_actions.fail" },
          ],
          current_value: -1,
        },
        {
          param: "profile_review_complete",
          label: "hotels.hotel_confirmations.profile_review",
          type: "select",
          options: [
            { value: "1", text: "competition.sanction.status.completed" },
            { value: "0", text: "competition.sanction.status.pending" },
            { value: "2", text: "miccamps.match_actions.fail" },
          ],
          current_value: -1,
        },
        {
          param: "gifts_complete",
          label: "hotels.hotel_confirmations.gifts",
          type: "select",
          options: [
            { value: "1", text: "competition.sanction.status.completed" },
            { value: "0", text: "competition.sanction.status.pending" },
            { value: "2", text: "miccamps.match_actions.fail" },
          ],
          current_value: -1,
        },
      ],
      default_filters: {
        status: 1,
      },
    },
  },
  page: {},
  current_filters: {},
  current_top_filters: {},
  history: [],
};

// getters
const getters = {
  getCurrentPage: (state, getters, rootState) => {
    return state.page;
  },

  getInfoCurrentPage: (state, getters, rootState) => {
    return state.history[state.history.length - 1];
  },

  getPreviousPage: (state, getters, rootState) => {
    return state.history.length > 1
      ? state.history[state.history.length - 2]
      : state.history[0];
  },

  getRouting: (state, getters, rootState) => {
    return state.routing;
  },

  getCurrentFilters: (state, getters, rootState) => {
    return state.current_filters;
  },

  getCurrentTopFilters: (state, getters, rootState) => {
    return state.current_filters;
  },
};

// actions
const actions = {
  backPage(context, pageCallBack) {
    var history = JSON.parse(JSON.stringify(context.state.history));
    var current_page = history.pop();
    // if (history.length > 0) {
    //     if (current_page.name != context.state.current_page) {
    //         context.commit('setHistory', history)
    //         router.push(current_page)
    //     }
    //     else {
    //         var page = history.pop()
    //         context.commit('setHistory', history)
    //         router.push(page)
    //     }
    // }
    // else {
    context.commit("setHistory", history);
    router.push({ path: pageCallBack });
    // }
  },
};

// mutations
const mutations = {
  pushPage(state, page) {
    if (!page.name.match(/.*(edit|add).*/)) {
      state.history.push({ name: page.name, params: page.params });
    }

    var pageName = page.name.replace("event_", "");
    var section = page.name.match("event_") ? "event" : "global";


    state.page = state.routing[pageName];
    state.current_filters =
      typeof state.routing[pageName][section] === "undefined" ||
      typeof state.routing[pageName][section].current_filters === "undefined"
        ? typeof state.routing[pageName].default_filters !== "undefined"
          ? state.routing[pageName].default_filters
          : {}
        : state.routing[pageName][section].current_filters;

    state.current_page = page.name;
  },

  setPage(state, page) {
    state.page = state.routing[page];
    state.current_filters =
      typeof state.routing[page].current_filters === "undefined"
        ? state.routing[page].default_filters
        : state.routing[page].current_filters;
  },

  setHiddenColumns(state, hidden_columns) {
    state.routing[store.state.current_page].hidden_columns = hidden_columns;
    state.page.hidden_columns = hidden_columns;
  },

  setCurrentFilters(state, payload) {
    state.current_filters =
      typeof payload.filters !== "undefined" ? payload.filters : {};
    var routing = { ...state.routing };
    var section =
      payload.event !== "undefined" && !payload.event ? "global" : "event";
    if (typeof routing[payload.page][section] === "undefined") {
      routing[payload.page][section] = {};
    }
    routing[payload.page][section].current_filters = payload.filters;

    state.routing = routing;
  },

  setCurrentTopFilters(state, payload) {
    state.current_filters = payload.filters;
    var routing = { ...state.routing };
    routing[payload.page].current_top_filters = payload.filters;

    state.routing = routing;
  },

  setHistory(state, history) {
    state.history = history;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
